import React, { useRef } from 'react';
import { Torus } from '@react-three/drei';

export default function CharacterGlasses({ visible = true, scale = 1, position = [0, 0, 0], rotation = [0, 0, 0] }) {
  const glassesRef = useRef();

  return (
    <group 
      ref={glassesRef} 
      scale={scale} 
      position={position} 
      rotation={rotation}
      visible={visible}
    >
      <Torus args={[1.1, 0.2, 5, 4]} position={[0,2.2,-2.5]} rotation-x = {0.5} rotation-z = {0.8}>
        <meshStandardMaterial color="black" />
      </Torus>
      <Torus args={[1, 0.2, 5, 4]} position={[2.3,2.2,-2.5]} rotation-x = {0.5} rotation-z = {0.8}>
        <meshStandardMaterial color="black" />
      </Torus>
    </group>
  );
} 